import { createDCHook, createMutationHook, collapseDataFromCall, collapseParams } from '../client';
import {
  getCallToActionBanner,
  bannerClosedAction,
  getFeatureBannerState,
  trackFeatureBannerInteraction,
  getTargetBanner,
} from '../services/BannerService';

export const useBannerGetCallToActionBanner = createDCHook(
  'getCallToActionBanner',
  collapseDataFromCall(getCallToActionBanner),
  { injectables: ['label', 'customerId', 'businessUnit'], flattenData: true },
);

export const useBannerBannerClosedAction = createMutationHook(bannerClosedAction, {
  injectables: ['label', 'customerId', 'businessUnit'],
  flattenData: false,
});

export const useBannerGetFeatureBannerState = createDCHook(
  'getFeatureBannerState',
  collapseDataFromCall(getFeatureBannerState),
  { injectables: ['label', 'customerId', 'businessUnit'], flattenData: true },
);

export const useBannerTrackFeatureBannerInteraction = createMutationHook(
  collapseParams(collapseParams(trackFeatureBannerInteraction, 'requestBody', 'data'), 'data', 'interactionType'),
  {
    injectables: ['label', 'customerId', 'businessUnit'],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['interactionType'] },
    ],
  },
);

export const useBannerGetTargetBanner = createDCHook('getTargetBanner', collapseDataFromCall(getTargetBanner), {
  injectables: ['label', 'customerId', 'businessUnit'],
  flattenData: true,
});
